{
  "DECK_SELECTOR_TITLE": "Meine Decks",
  "MAP_SELECT_TITLE": "Karte auswählen",
  "DECKBUILDER_TAB_TOWERS": "TÜRME",
  "DECKBUILDER_TAB_UNITS": "EINHEITEN",
  "DECKBUILDER_TAB_HERO": "HELD",
  "HUD_CLOSE": "Schließen",
  "HUD_SURRENDER": "Aufgeben",
  "HUD_SURRENDER_CONFIRM": "Wirklich aufgeben?",
  "HUD_WAVE": "Welle",
  "HUD_DAILY_QUESTS": "TÄGLICHE QUESTS",
  "HUD_NO_ACTIVE_QUESTS": "Keine aktiven Quests",
  "HUD_SPELL_READY": "Bereit",
  "HUD_SPY_LABEL": "SPY",
  "HUD_UPGRADE": "Upgrade",
  "HUD_MAX_LEVEL": "MAX LEVEL",
  "HUD_DEMOLISH": "Abreißen (50% Rückgabe)",
  "HUD_CHOOSE_PATH": "Pfad wählen (irreversibel):",
  "HUD_MUSIC_ON": "Musik einschalten",
  "HUD_MUSIC_OFF": "Musik ausschalten",
  "MATCH_RESULT_NO_STATS": "Keine Statistiken verfügbar",
  "MATCH_RESULT_VICTORY": "SIEG",
  "MATCH_RESULT_DEFEAT": "NIEDERLAGE",
  "MATCH_RESULT_DRAW": "UNENTSCHIEDEN",
  "MATCH_RESULT_WINNER": "Gewinner:",
  "MATCH_RESULT_TOTAL_DAMAGE": "Schaden gesamt:",
  "MATCH_RESULT_GOLD_EARNED": "Gold verdient:",
  "MATCH_RESULT_UNITS_SENT": "Einheiten gesendet:",
  "MATCH_RESULT_TOWERS_BUILT": "Türme gebaut:",
  "MATCH_RESULT_DURATION": "Spielzeit:",
  "MATCH_RESULT_PLAY_AGAIN": "Nochmal spielen",
  "MATCH_RESULT_MAIN_MENU": "Hauptmenü",
  "MATCH_RESULT_PLAYER": "Du",
  "MATCH_RESULT_OPPONENT": "Gegner",
  "MATCH_RESULT_TOWER_DAMAGE": "Turmschaden",
  "MATCH_RESULT_UNITS_BREAKDOWN": "Einheiten gesendet",
  "CAMPAIGN_HUD_OBJECTIVE": "Missionsziel:",
  "SHOP_TITLE": "Shop",
  "SHOP_GOLD_LABEL": "Gold:",
  "SHOP_GEMS_COMING_SOON": "Edelstein-Käufe werden in der nächsten Version verfügbar sein.",
  "SHOP_SEASON_COMING_SOON": "Abonnieren — Coming Soon",
  "SHOP_TAB_PACKS": "Packs",
  "SHOP_TAB_GEMS": "Edelsteine",
  "SHOP_TAB_SEASON": "Saison-Pass",
  "SHOP_BUY": "Kaufen",
  "SHOP_NOT_ENOUGH_GOLD": "Zu wenig Gold",
  "SHOP_GEMS_LABEL": "Edelsteine",
  "SHOP_COMING_SOON_BADGE": "Bald verfügbar",
  "SHOP_SUBSCRIBE": "Abonnieren — Coming Soon",
  "SHOP_DURATION_DAYS": "Dauer:",
  "QUEST_WIDGET_TITLE": "Aktive Quests",
  "QUEST_WIDGET_ALL_LINK": "Alle Quests →",
  "MAIN_MENU_TITLE": "Ultimaze Tower Wars",
  "MAIN_MENU_PLAY_PVP": "⚔ PvP — Jetzt spielen",
  "MAIN_MENU_PLAY": "vs Bot spielen",
  "MAIN_MENU_DECK_BUILDER": "🃏 Deck Builder",
  "MAIN_MENU_MY_DECKS": "📂 Meine Decks",
  "MAIN_MENU_SHOP": "🛒 Shop",
  "MAIN_MENU_INVENTORY": "🎒 Inventar",
  "MAIN_MENU_PROFILE": "📊 PROFIL",
  "MAIN_MENU_SETTINGS": "⚙ Einstellungen",
  "MAIN_MENU_LOGIN_REGISTER": "Login / Registrieren",
  "MAIN_MENU_LOGOUT": "Abmelden",
  "INVENTORY_TITLE": "Inventar",
  "INVENTORY_BACK": "← Zurück",
  "INVENTORY_EMPTY": "Keine ungeöffneten Packs",
  "INVENTORY_EMPTY_SHOP_LINK": "→ Zum Shop",
  "INVENTORY_OPEN_BTN": "Öffnen",
  "INVENTORY_PACKS_SECTION": "Ungeöffnete Packs",
  "SETTINGS_TITLE": "Einstellungen",
  "SETTINGS_LANGUAGE": "Sprache",
  "SETTINGS_BACK": "← Zurück",
  "SETTINGS_SOUND": "Sound",
  "LOGIN_TITLE": "Anmelden",
  "LOGIN_EMAIL": "E-Mail",
  "LOGIN_PASSWORD": "Passwort",
  "LOGIN_SUBMIT": "Anmelden",
  "LOGIN_REGISTER_LINK": "Noch kein Konto? Registrieren →",
  "LOGIN_GUEST": "Als Gast spielen →",
  "LOGIN_FORGOT_PASSWORD": "Passwort vergessen?",
  "LOGIN_RESET_SEND": "Reset-Link senden",
  "LOGIN_RESET_SENT": "Falls diese E-Mail registriert ist, wurde ein Reset-Link gesendet.",
  "LOGIN_BACK_TO_LOGIN": "← Zurück zur Anmeldung",
  "REGISTER_TITLE": "Registrieren",
  "REGISTER_DISPLAYNAME": "Anzeigename",
  "REGISTER_SUBMIT": "Registrieren",
  "REGISTER_LOGIN_LINK": "Bereits registriert? Anmelden →",
  "REGISTER_CONFIRM_PASSWORD": "Passwort bestätigen",
  "REGISTER_PASSWORD_TOO_SHORT": "Das Passwort muss mindestens 8 Zeichen lang sein.",
  "REGISTER_PASSWORDS_MISMATCH": "Die Passwörter stimmen nicht überein.",
  "LEADERBOARD_TITLE": "🏆 Rangliste",
  "LEADERBOARD_GLOBAL": "Global",
  "LEADERBOARD_NATIONAL": "National",
  "LEADERBOARD_LOADING": "Daten werden geladen...",
  "LEADERBOARD_BACK": "← Zurück",
  "LEADERBOARD_MY_POSITION": "Deine Position:",
  "LEADERBOARD_TOTAL_PLAYERS": "{{count}} Spieler insgesamt",
  "LEADERBOARD_MONTH_LABEL": "Monat auswählen",
  "LEADERBOARD_EMPTY": "Keine Einträge gefunden.",
  "AUTH_ERROR_INVALID_CREDENTIALS": "E-Mail oder Passwort falsch.",
  "AUTH_ERROR_EMAIL_TAKEN": "Diese E-Mail-Adresse ist bereits vergeben.",
  "AUTH_ERROR_NETWORK": "Netzwerkfehler. Bitte versuche es erneut.",
  "AUTH_LOGIN_TITLE": "Anmelden",
  "AUTH_REGISTER_TITLE": "Registrieren",
  "AUTH_FORGOT_TITLE": "Passwort zurücksetzen",
  "AUTH_EMAIL": "E-Mail",
  "AUTH_USERNAME": "Benutzername",
  "AUTH_PASSWORD": "Passwort",
  "AUTH_CONFIRM_PASSWORD": "Passwort bestätigen",
  "AUTH_LOGIN_BTN": "Anmelden",
  "AUTH_REGISTER_BTN": "Registrieren",
  "AUTH_FORGOT_BTN": "Reset-Link senden",
  "AUTH_GUEST_BTN": "Als Gast spielen",
  "AUTH_SWITCH_TO_REGISTER": "Noch kein Konto? Registrieren",
  "AUTH_SWITCH_TO_LOGIN": "Bereits ein Konto? Anmelden",
  "AUTH_SWITCH_TO_FORGOT": "Passwort vergessen?",
  "AUTH_SWITCH_TO_LOGIN_FROM_FORGOT": "Zurück zur Anmeldung",
  "AUTH_FORGOT_SUCCESS": "Falls diese E-Mail registriert ist, wurde ein Reset-Link gesendet.",
  "AUTH_MAIN_MENU_GREETING": "Hallo, {{username}}",
  "AUTH_LOGOUT_BTN": "Abmelden",
  "AUTH_LOGIN_REGISTER_BTN": "Anmelden / Registrieren",
  "AUTH_ERROR_PASSWORDS_MISMATCH": "Passwörter stimmen nicht überein",
  "AUTH_ERROR_USERNAME_TOO_SHORT": "Benutzername muss mindestens 3 Zeichen haben",
  "AUTH_ERROR_PASSWORD_TOO_SHORT": "Passwort muss mindestens 6 Zeichen haben",
  "PROGRESSION_TITLE": "Spielerprofil",
  "PROGRESSION_BACK": "← Zurück",
  "PROGRESSION_EXPERIENCE": "Erfahrung",
  "PROGRESSION_CURRENCY": "Währung",
  "PROGRESSION_GOLD": "Gold",
  "PROGRESSION_GEMS": "Edelsteine",
  "PROGRESSION_PACK_PROGRESS": "Pack-Fortschritt",
  "PROGRESSION_OPEN_PACK": "🎁 Pack öffnen!",
  "PROGRESSION_DAILY_QUESTS": "Tägliche Quests",
  "PROGRESSION_WEEKLY_QUESTS": "Wöchentliche Quests",
  "PROGRESSION_ACHIEVEMENT_QUESTS": "Erfolgsquests",
  "PROGRESSION_ACHIEVEMENTS": "Erfolge (zuletzt freigeschaltet)",
  "PROGRESSION_CARD_COLLECTION": "Kartensammlung",
  "PROGRESSION_CARDS_COLLECTED": "{{owned}}/{{total}} Karten gesammelt",
  "PROGRESSION_DAILY_PACK": "🎁 Tagespaket",
  "PROGRESSION_FRIENDS": "👥 Freunde",
  "PROGRESSION_CLAIM": "Abholen",
  "DECK_SELECTOR_BACK": "← Zurück",
  "DECK_SELECTOR_NEW_DECK": "+ Neues Deck",
  "DECK_SELECTOR_SELECTED": "(ausgewählt)",
  "DECK_SELECTOR_CARDS": "Karten",
  "DECK_SELECTOR_EDIT": "Bearbeiten",
  "DECK_BUILDER_CANCEL": "Abbrechen",
  "DECK_BUILDER_SAVE": "Speichern",
  "DECK_BUILDER_NAME_PLACEHOLDER": "Deck-Name",
  "DECK_BUILDER_TOTAL_COST": "Gesamtkosten:",
  "DECK_BUILDER_TOWERS_SECTION": "TÜRME",
  "DECK_BUILDER_UNITS_SECTION": "EINHEITEN",
  "DECK_BUILDER_HERO_SECTION": "HELD",
  "DECK_BUILDER_ELEMENTS": "Elemente",
  "DECK_BUILDER_FILTER_ALL": "Alle",
  "DECK_BUILDER_EMPTY_SLOT": "Leer — Tippen zum Hinzufügen",
  "DECK_BUILDER_NO_TOWERS": "Keine Türme für dieses Element.",
  "DECK_BUILDER_NO_UNITS": "Keine Einheiten für dieses Element.",
  "DECK_BUILDER_TAB_TOWERS": "Türme",
  "DECK_BUILDER_TAB_UNITS": "Einheiten",
  "DECK_BUILDER_TAB_HEROES": "Helden",
  "DECK_BUILDER_CHOOSE_TOWER_SLOT": "Karte für Turmslot {{slot}} auswählen — oder Slot erneut tippen zum Schliessen",
  "DECK_BUILDER_CHOOSE_UNIT_SLOT": "Karte für Einheitenslot {{slot}} auswählen",
  "DECK_BUILDER_CHOOSE_HERO": "Helden auswählen",
  "DECK_BUILDER_ERROR_NAME": "Deck-Name ist erforderlich.",
  "DECK_BUILDER_ERROR_HERO": "Ein Held ist erforderlich.",
  "DECK_BUILDER_ERROR_TOWERS": "Mindestens 1 Turm ist erforderlich.",
  "MATCHMAKING_TITLE": "GEGNER SUCHEN",
  "MATCHMAKING_SEARCHING": "Suche läuft... {{seconds}}s",
  "MATCHMAKING_FOUND": "Gegner gefunden: {{name}}!",
  "MATCHMAKING_ERROR": "Verbindungsfehler",
  "MATCHMAKING_VS_BOT": "Gegen Bot spielen",
  "MATCHMAKING_RETRY": "Erneut versuchen",
  "MATCHMAKING_CANCEL": "Abbrechen",
  "MATCHMAKING_RANK_LABEL": "Dein Rang",
  "MATCHMAKING_QUEUE_POSITION": "Position in der Warteschlange: {{position}}",
  "MATCHMAKING_RELAXING": "Suchbereich wird erweitert...",
  "MATCHMAKING_OPPONENT_RANK": "Gegner-Rang: {{mmr}}",
  "MATCHMAKING_SERVER_OFFLINE": "Server nicht erreichbar",
  "MATCHMAKING_SERVER_OFFLINE_DESC": "Kein Internet oder Server offline — du spielst offline gegen einen Bot",
  "MATCHMAKING_FALLBACK_TITLE": "Kein Gegner gefunden",
  "MATCHMAKING_FALLBACK_DESC": "Du spielst jetzt gegen einen Bot",
  "MATCHMAKING_FALLBACK_STARTING": "Match startet...",
  "PACK_OPEN_TITLE": "Pack öffnen",
  "PACK_OPEN_CLOSE": "Schließen",
  "PACK_OPEN_NEW": "NEU",
  "DAILY_PACK_CLAIM": "🎁 Gratis Pack holen!",
  "DAILY_PACK_TOMORROW": "Morgen wieder verfügbar — {{countdown}}",
  "HUD_TOOLTIP_DAMAGE": "Schaden",
  "HUD_TOOLTIP_SPEED": "Tempo",
  "HUD_TOOLTIP_RANGE": "Reichweite",
  "HUD_TOOLTIP_CRIT": "Krit",
  "HUD_TOOLTIP_SLOW": "Verlangsamung",
  "HUD_TOOLTIP_CHAIN": "Kettensprünge",
  "HUD_TOOLTIP_INCOME": "Einkommen",
  "HUD_TOOLTIP_ARMOR": "Rüstung",
  "HUD_TOOLTIP_DODGE": "Ausweichen",
  "HUD_TOOLTIP_KILL_REWARD": "Kill-Belohnung",
  "HUD_QUEST_CLAIMED": "abgeholt",
  "HUD_SOUND_OFF": "Sound aus",
  "HUD_SOUND_ON": "Sound an",
  "HUD_ROTATE_VIEW": "Ansicht drehen (R)",
  "HUD_BUILD": "Bauen",
  "HUD_SEND_UNIT": "Einheit senden",
  "HUD_SPY_ENEMY": "Gegner beobachten",
  "HUD_CANCEL_PLACEMENT": "Platzierung abbrechen",
  "HUD_BASE_MAX": "Basis MAX",
  "RARITY_COMMON": "Gewöhnlich",
  "RARITY_RARE": "Selten",
  "RARITY_EPIC": "Episch",
  "RARITY_LEGENDARY": "Legendär",
  "PHASER_GOLD_UNIT": "G",
  "PHASER_PACK_TAP_HINT": "Tippe auf eine Karte zum Aufdecken",
  "PHASER_PACK_REVEAL_ALL": "Alle aufdecken",
  "PHASER_PACK_CLOSE": "Schließen",
  "PHASER_PACK_NEW_BADGE": "NEU!",

  "MAP_SELECT_BACK": "← Zurück",
  "MAP_SELECT_DESC_VULKAN": "Vulkanisches Terrain mit engen Pfaden",
  "MAP_SELECT_DESC_KUESTENFORT": "Küstenfestung mit Wasserübergängen",
  "MAP_SELECT_DESC_RUINEN": "Alte Ruinen mit mehreren Routen",
  "MAP_SELECT_DESC_EISOEDE": "Gefrorene Tundra mit kristallenen Eisblöcken",
  "MAP_SELECT_DESC_WUESTE": "Sandverwehte Arena mit diagonalen Dünenrücken",
  "MAP_SELECT_DESC_DSCHUNGEL": "Dichtes Dschungellabyrinth mit verwobenen Pfaden",
  "MAP_SELECT_DESC_HOCHGEBIRGE": "Alpines Schlachtfeld mit Felsvorsprüngen — Natur und Licht dominieren",
  "MAP_SELECT_DESC_SUMPF": "Nebelverhangener Sumpf mit verwinkelten Moorpfaden — Wasser und Schatten herrschen",

  "HUD_SPELL_COOLDOWN_LABEL": "Cooldown",
  "HUD_SPELL_COOLDOWN_REMAINING": "noch {{secs}}s",
  "HUD_SPELL_READY_Q": "Bereit (Q)",

  "HUD_TOOLTIP_SPLASH": "Flächenschaden",
  "HUD_TOOLTIP_RANGE_CELLS": "Zellen Reichweite",

  "SETTINGS_ACCOUNT": "Konto",
  "SETTINGS_USERNAME": "Benutzername",
  "SETTINGS_EMAIL": "E-Mail",
  "SETTINGS_PASSWORD": "Passwort",
  "SETTINGS_CHANGE_PASSWORD": "Passwort ändern",
  "SETTINGS_SERVER": "Server",
  "SETTINGS_SOCIAL": "Social Media verknüpfen",
  "SETTINGS_SOCIAL_CONNECT": "Verknüpfen",
  "SETTINGS_SOCIAL_CONNECTED": "Verbunden",
  "SETTINGS_SOCIAL_DISCONNECT": "Trennen",
  "SETTINGS_PAYMENT": "Zahlungsmethoden",
  "SETTINGS_PAYMENT_ADD": "Hinzufügen",
  "SETTINGS_PAYMENT_CONNECTED": "Verknüpft",
  "SETTINGS_PAYMENT_REMOVE": "Entfernen",
  "SETTINGS_CURRENT_PASSWORD": "Aktuelles Passwort",
  "SETTINGS_SAVE": "Speichern",
  "SETTINGS_SAVING": "Wird gespeichert...",
  "SETTINGS_SAVED": "Gespeichert ✓",
  "SETTINGS_SAVE_ERROR": "Fehler beim Speichern — bitte erneut versuchen",
  "SETTINGS_GUEST_NOTE": "Nicht eingeloggt — Spracheinstellung wird lokal gespeichert",
  "TUTORIAL_STEP_1_TITLE": "Willkommen bei Ultimaze Tower Wars!",
  "TUTORIAL_STEP_1_DESC": "Baue ein Labyrinth aus Türmen, schicke Einheiten zum Gegner und zerstöre seine Basis — bevor er deine zerstört!",
  "TUTORIAL_STEP_2_TITLE": "Türme bauen",
  "TUTORIAL_STEP_2_DESC": "Tippe auf eine freie Zelle, wähle einen Turm aus deiner Hand. Türme schießen automatisch auf Einheiten. Wichtig: Du darfst den Weg nie vollständig blockieren!",
  "TUTORIAL_STEP_3_TITLE": "Einheiten senden",
  "TUTORIAL_STEP_3_DESC": "Schicke Einheiten zum Gegner! Jede gesendete Einheit erhöht dauerhaft dein Einkommen. Je schneller sie die Basis erreichen, desto mehr Schaden richten sie an.",
  "TUTORIAL_STEP_4_TITLE": "Elementstärken nutzen",
  "TUTORIAL_STEP_4_DESC": "Jedes Element hat Stärken und Schwächen. Baue dein Deck um Synergie-Elemente auf!",
  "TUTORIAL_STEP_4_ELEMENT_CYCLE": "Feuer → Natur → Wasser → Feuer (je 1.8×)\nElektro → Wasser (2.0× — schärfster Konter!)",
  "TUTORIAL_STEP_4_AXIS": "Licht ↔ Schatten: beide 2.0× — harter Konter in beide Richtungen!",
  "TUTORIAL_STEP_5_TITLE": "Bereit fürs erste Match!",
  "TUTORIAL_STEP_5_DESC": "Tutorial abgeschlossen! Deine Belohnung:",
  "TUTORIAL_NEXT": "Weiter →",
  "TUTORIAL_SKIP": "Überspringen",
  "TUTORIAL_COMPLETE": "Match starten! 🎮",
  "TUTORIAL_REWARD_TITLE": "Tutorial-Belohnung",
  "TUTORIAL_REWARD_XP": "+150 XP",
  "TUTORIAL_REWARD_GOLD": "+200 Gold",
  "TUTORIAL_REWARD_PACK": "+1 Starter Pack",
  "TUTORIAL_ACHIEVEMENT_UNLOCKED": "🏆 Erfolg freigeschaltet: Tutorial abgeschlossen!",
  "TOAST_QUEST_COMPLETED": "Quest abgeschlossen: {{title}}",
  "TOAST_ACHIEVEMENT_UNLOCKED": "🏆 Erfolg: {{title}}",
  "TOAST_MATCH_WIN": "Sieg! +{{xp}} XP erhalten",
  "TOAST_REWARD_CLAIMED": "Belohnung erhalten: +{{xp}} XP, +{{gold}} Gold",
  "TOAST_TUTORIAL_REWARD": "🎁 Tutorial-Belohnung erhalten! +150 XP, +200 Gold, +1 Pack",
  "FEEDBACK_TITLE": "Feedback & Bugreport",
  "FEEDBACK_BACK": "Zurück",
  "FEEDBACK_TYPE_LABEL": "Typ",
  "FEEDBACK_TYPE_BUG": "🪲 Bug",
  "FEEDBACK_TYPE_IDEA": "💡 Idee",
  "FEEDBACK_TYPE_OTHER": "💬 Sonstiges",
  "FEEDBACK_TITLE_LABEL": "Titel",
  "FEEDBACK_TITLE_PLACEHOLDER": "Kurzbeschreibung (max. 120 Zeichen)",
  "FEEDBACK_DESC_LABEL": "Beschreibung",
  "FEEDBACK_DESC_PLACEHOLDER": "Was ist passiert? Schritte zur Reproduktion, Vorschlag, etc. (max. 2000 Zeichen)",
  "FEEDBACK_SUBMIT": "Absenden",
  "FEEDBACK_SUBMITTING": "Wird gesendet...",
  "FEEDBACK_SUCCESS_TITLE": "Danke für dein Feedback!",
  "FEEDBACK_SUCCESS_DESC": "Wir nehmen jeden Bericht ernst. Halte deine Report-ID bereit, um den Status zu prüfen.",
  "FEEDBACK_SUCCESS_ID": "Deine Report-ID:",
  "FEEDBACK_ERROR": "Fehler beim Senden. Bitte versuche es erneut.",
  "FEEDBACK_VALIDATION_REQUIRED": "Bitte alle Felder ausfüllen.",
  "FEEDBACK_MY_REPORTS_TITLE": "Meine Berichte",
  "FEEDBACK_STATUS_NEW": "🆕 Eingegangen",
  "FEEDBACK_STATUS_REVIEWING": "🔍 In Prüfung",
  "FEEDBACK_STATUS_CONFIRMED": "✅ Bestätigt",
  "FEEDBACK_STATUS_RESOLVED": "🔧 Behoben",
  "FEEDBACK_STATUS_REJECTED": "❌ Abgelehnt",
  "FEEDBACK_ACHIEVEMENT_HINT": "Bestätigte & behobene Berichte zählen für den Bug-Tracker-Erfolg!",
  "FEEDBACK_BTN_REPORT": "Feedback / Bug melden",
  "ERROR_BOUNDARY_HEADING": "Etwas ist schiefgelaufen",
  "ERROR_BOUNDARY_RELOAD": "Neu laden",
  "OFFLINE_BANNER_TEXT": "Keine Internetverbindung — PvP und Online-Funktionen sind nicht verfügbar",
  "PUSH_MODAL_TITLE": "Bleib im Spiel!",
  "PUSH_MODAL_BODY": "Erhalte tägliche Pack-Erinnerungen und Benachrichtigungen wenn Gegner gefunden wurden.",
  "PUSH_MODAL_BULLET_PACK": "✅ Kostenlose Pack-Erinnerungen",
  "PUSH_MODAL_BULLET_PVP": "✅ PvP Match-Benachrichtigungen",
  "PUSH_MODAL_ACCEPT": "Ja, Benachrichtigungen erlauben",
  "PUSH_MODAL_SETTING_UP": "Wird eingerichtet...",
  "PUSH_MODAL_DECLINE": "Nicht jetzt",
  "LEADERBOARD_COL_RANK": "#",
  "LEADERBOARD_COL_NAME": "Name",
  "LEADERBOARD_COL_COUNTRY": "Land",
  "LEADERBOARD_COL_POINTS": "Punkte",
  "LEADERBOARD_COL_LEAGUE": "Liga",
  "LEADERBOARD_TAB_GLOBAL": "Global",
  "LEADERBOARD_TAB_FRIENDS": "Freunde",
  "LEADERBOARD_RANK": "#",
  "LEADERBOARD_PLAYER": "Spieler",
  "LEADERBOARD_RECORD": "S-N",
  "LEADERBOARD_POINTS": "ELO",
  "LEADERBOARD_LOGIN_PROMPT": "Melde dich an um die Rangliste zu sehen",
  "LEADERBOARD_YOU": "Du",
  "SETTINGS_SOCIAL_SHARING_NOTE": "Teile Decks, Match-Stats und Leaderboard-Ergebnisse direkt über deine Social-Media-Kanäle.",
  "SETTINGS_PAYMENT_NOTE": "Wir speichern keine Zahlungsdaten. Die Verarbeitung erfolgt ausschließlich über den jeweiligen Anbieter (PayPal, Apple Pay, etc.).",
  "MAP_SELECT_SYNERGY": "SYNERGIE",
  "BOT_NAMES": ["Valdris der Dunkle", "Sylara die Schnelle", "Gorak Steinbrecher", "Mira Flammenherz", "Theron der Wächter", "Nyx Schattenweber", "Aldric der Unbesiegte", "Sora Windklinge"],
  "MATCHMAKING_ANON_PREFIX": "Spieler",
  "ELEMENT_NAME_FIRE": "Feuer",
  "ELEMENT_NAME_WATER": "Wasser",
  "ELEMENT_NAME_NATURE": "Natur",
  "ELEMENT_NAME_ELEKTRO": "Elektro",
  "ELEMENT_NAME_LIGHT": "Licht",
  "ELEMENT_NAME_SHADOW": "Schatten",
  "ELEMENT_NAME_NEUTRAL": "Neutral",
  "QUEST_SEND_UNITS_10": "Sende 10 Einheiten",
  "QUEST_WIN_MATCH": "Gewinne ein Match",
  "QUEST_BUILD_20_TOWERS": "Baue 20 Türme in einer Runde",
  "QUEST_WIN_5_PVP": "Gewinne 5 PvP-Matches",
  "QUEST_COMPLETE_TUTORIAL": "Tutorial abgeschlossen",
  "QUEST_BUG_TRACKER_BRONZE": "🪲 Bug-Tracker Bronze",
  "QUEST_BUG_TRACKER_SILBER": "🪲 Bug-Tracker Silber",
  "QUEST_BUG_TRACKER_GOLD": "🪲 Bug-Tracker Gold",
  "QUEST_BUG_TRACKER_PLATIN": "🪲 Bug-Tracker Platin",
  "QUEST_BUG_TRACKER_DIAMANT": "🪲 Bug-Tracker Diamant",
  "QUEST_SEND_UNITS_10_DESC": "Sende in einem Match 10 Einheiten auf den Gegner.",
  "QUEST_WIN_MATCH_DESC": "Gewinne ein Match gegen einen Gegner oder Bot.",
  "QUEST_BUILD_20_TOWERS_DESC": "Platziere in einer einzigen Runde 20 Türme auf dem Grid.",
  "QUEST_WIN_5_PVP_DESC": "Gewinne diese Woche 5 PvP-Matches.",
  "BOOT_LOADING_GAMEDATA": "Lade Spieldaten...",
  "BOOT_LOADING_READY": "Bereit!",
  "FRIENDS_TAB_LIST": "Freunde",
  "FRIENDS_TAB_REQUESTS": "Anfragen",
  "FRIENDS_TAB_SEARCH": "Suchen",
  "FRIENDS_LOADING": "Lade Freundesliste...",
  "FRIENDS_EMPTY": "Du hast noch keine Freunde. Suche nach Spielern!",
  "FRIENDS_NO_REQUESTS": "Keine offenen Anfragen.",
  "FRIENDS_CHALLENGE": "Herausforderung senden",
  "FRIENDS_CHALLENGE_SENT": "Herausforderung gesendet! 60 Sekunden Zeit.",
  "FRIENDS_CHALLENGE_OFFLINE": "Dieser Spieler ist gerade nicht online.",
  "FRIENDS_ACCEPT": "Annehmen",
  "FRIENDS_DECLINE": "Ablehnen",
  "FRIENDS_REQUEST_ACCEPTED": "Freundschaftsanfrage angenommen!",
  "FRIENDS_REQUEST_SENT": "Anfrage gesendet!",
  "FRIENDS_REQUEST_ERROR": "Fehler beim Senden der Anfrage.",
  "FRIENDS_ADD": "Hinzufügen",
  "FRIENDS_ALREADY_FRIENDS": "Bereits befreundet",
  "FRIENDS_PENDING": "Anfrage ausstehend",
  "FRIENDS_SEARCH_PLACEHOLDER": "Name oder #CODE eingeben...",
  "FRIENDS_SEARCHING": "Suche...",
  "FRIENDS_SEARCH_EMPTY": "Kein Spieler gefunden.",
  "FRIENDS_LOGIN_REQUIRED": "Bitte melde dich an, um das Freundessystem zu nutzen.",

  "INVENTORY_TAB_PACKS": "Packs",
  "INVENTORY_TAB_CARDS": "Karten",
  "INVENTORY_CARDS_EMPTY": "Noch keine Karten. Öffne Packs!",
  "INVENTORY_CARD_COPIES": "{{copies}}×",

  "CARD_DETAIL_BACK": "Zurück",
  "CARD_DETAIL_NOT_FOUND": "Karte nicht gefunden.",
  "CARD_DETAIL_LEVEL": "Lv. {{level}}",
  "CARD_DETAIL_COPIES_TO_NEXT": "{{have}} / {{needed}} Kopien für nächstes Level",
  "CARD_DETAIL_MAX_LEVEL": "MAX LEVEL erreicht",
  "CARD_DETAIL_LEVEL_BONUSES": "Level-Boni",
  "CARD_DETAIL_STATS": "Werte",
  "CARD_DETAIL_STATS_BASE": "Basis",
  "CARD_DETAIL_STATS_CURRENT": "Aktuell",
  "CARD_DETAIL_SKILL_TREE": "Skill-Baum",
  "CARD_DETAIL_GATE_LEVEL": "Gate Lv. {{level}}",
  "CARD_DETAIL_GATE_LOCKED": "gesperrt (Lv. {{level}} benötigt)",
  "CARD_DETAIL_GATE_CHOOSE": "Wählen!",
  "CARD_DETAIL_GATE_DONE": "gewählt",
  "CARD_DETAIL_CHOOSE": "Wählen",
  "CARD_DETAIL_NODE_REQUIRES": "Benötigt: {{id}}",
  "CARD_DETAIL_RESET": "Zurücksetzen ({{cost}} 💎)",
  "CARD_DETAIL_RESET_NO_GEMS": "Nicht genug Edelsteine (150 benötigt)",
  "CARD_DETAIL_CAT_TOWER": "TURM",
  "CARD_DETAIL_CAT_UNIT": "EINHEIT",
  "CARD_DETAIL_CAT_HERO": "HELD",
  "CARD_DETAIL_STAT_DMG": "Schaden",
  "CARD_DETAIL_STAT_SPD": "Geschwindigkeit",
  "CARD_DETAIL_STAT_RANGE": "Reichweite",
  "CARD_DETAIL_STAT_CRIT": "Krit.-Chance",
  "CARD_DETAIL_STAT_SPLASH": "Flächenschaden",
  "CARD_DETAIL_STAT_SLOW": "Verlangsamung",
  "CARD_DETAIL_STAT_CHAIN": "Kettenangriff",
  "CARD_DETAIL_STAT_INCOME": "Einkommen",
  "CARD_DETAIL_STAT_ARMOR": "Rüstung",
  "CARD_DETAIL_STAT_DODGE": "Ausweichen",
  "CARD_DETAIL_STAT_PASSIVE": "Passiv",
  "CARD_DETAIL_STAT_COOLDOWN": "Cooldown",

  "CHALLENGE_MODAL_TITLE": "Kampfherausforderung!",
  "CHALLENGE_MODAL_FROM": "{{name}} fordert dich heraus!",
  "CHALLENGE_MODAL_ACCEPT": "Annehmen",
  "CHALLENGE_MODAL_DECLINE": "Ablehnen",
  "CHALLENGE_MODAL_EXPIRES": "Läuft ab in {{seconds}}s",

  "LOGIN_OR": "oder",
  "LOGIN_GOOGLE": "Mit Google anmelden",

  "TUTORIAL_DECK_TITLE": "Baue dein erstes Deck",
  "TUTORIAL_DECK_DESC": "Wähle 8 Türme, 4 Einheiten und 1 Held für dein Starter-Deck.",
  "TUTORIAL_DECK_CONFIRM": "Deck bestätigen & starten",
  "TUTORIAL_DECK_NAME": "Mein erstes Deck",

  "MODE_SELECT_TITLE": "Spielmodus wählen",
  "MODE_SELECT_SUB": "Wie viele Spieler sollen kämpfen?",
  "MODE_1V1_TITLE": "1 gegen 1",
  "MODE_1V1_DESC": "Klassisches Duell — du gegen einen Gegner",
  "MODE_2V2_TITLE": "2 gegen 2",
  "MODE_2V2_DESC": "Team-Kampf mit einem Mitspieler",
  "MODE_3V3_TITLE": "3 gegen 3",
  "MODE_3V3_DESC": "Große Teamschlacht — 3 vs. 3",

  "MAIN_MENU_CAMPAIGN": "📖 Solo-Kampagne",

  "CAMPAIGN_TITLE": "Solo-Kampagne",
  "CAMPAIGN_SUBTITLE": "5 Missionen — von Anfänger bis Champion",
  "CAMPAIGN_MISSION_N": "Mission {{n}}",
  "CAMPAIGN_OBJECTIVE": "Ziel",
  "CAMPAIGN_HINT": "Schließe eine Mission ab um die nächste freizuschalten.",
  "CAMPAIGN_COMPLETE_TOAST": "Mission abgeschlossen! +{{xp}} XP, +{{gold}} Gold",
  "CAMPAIGN_FAIL_TOAST": "Mission fehlgeschlagen — versuche es erneut!",

  "CAMPAIGN_M1_TITLE": "Erste Schritte",
  "CAMPAIGN_M1_DESC": "Ein Anfänger-Bot wartet auf dich. Lerne die Grundlagen!",
  "CAMPAIGN_M1_OBJ": "Gegnerische Basis zerstören",

  "CAMPAIGN_M2_TITLE": "Die Horde",
  "CAMPAIGN_M2_DESC": "Der Angreifer schickt endlose Einheiten. Halte die Stellung!",
  "CAMPAIGN_M2_OBJ": "30 feindliche Einheiten besiegen",

  "CAMPAIGN_M3_TITLE": "Goldgräber",
  "CAMPAIGN_M3_DESC": "Optimiere deinen Wirtschafts-Loop gegen einen defensiven Gegner.",
  "CAMPAIGN_M3_OBJ": "10 Gold/Sekunde Einkommen erreichen",

  "CAMPAIGN_M4_TITLE": "Flut der Kreaturen",
  "CAMPAIGN_M4_DESC": "Ein Schwarm-Bot bombardiert dich ohne Pause. Überlebe 8 Minuten!",
  "CAMPAIGN_M4_OBJ": "8 Minuten überleben",

  "CAMPAIGN_M5_TITLE": "Der Champion",
  "CAMPAIGN_M5_DESC": "Der klügste Bot — nutzt Elementgegenüberstellungen und passt sich an. Nur die Besten bezwingen ihn.",
  "CAMPAIGN_M5_OBJ": "Basis des Champions zerstören",

  "MAIN_MENU_COOP": "🤝 Koop PvE",
  "COOP_MATCHMAKING_TITLE": "Koop PvE",
  "COOP_MATCHMAKING_SEARCHING": "Suche Mitspieler...",
  "COOP_MATCHMAKING_FOUND": "Mitspieler gefunden!",
  "COOP_MATCHMAKING_PARTNER": "Partner: {{name}}",
  "COOP_MATCHMAKING_STARTING": "Starte gemeinsamen Angriff...",
  "COOP_MATCHMAKING_FALLBACK": "Kein Partner gefunden",
  "COOP_MATCHMAKING_FALLBACK_DESC": "Du kämpfst allein gegen die Bots.",
  "COOP_MATCHMAKING_CANCEL": "Abbrechen",
  "COOP_MATCHMAKING_OFFLINE": "Server nicht erreichbar",
  "COOP_MATCHMAKING_OFFLINE_DESC": "Solo-Koop: Du verteidigst allein gegen Bots.",
  "HUD_COOP_PARTNER_HP": "Partner ♥",
  "HUD_COOP_PARTNER_DEFEATED": "Partner besiegt!",

  "SEASON_DAYS_LEFT": "{{days}} Tage verbleibend",
  "SEASON_LEVEL_LABEL": "Level {{level}} / {{max}}",
  "SEASON_PREMIUM_DESC": "Schalte den Premium-Pfad frei — exklusive Edelsteine, Packs und Titel für jedes Level.",
  "SEASON_BUY_PASS": "Saison-Pass kaufen",
  "SEASON_PREMIUM_ACTIVE": "Premium-Pfad freigeschaltet — alle Premium-Belohnungen verfügbar!",
  "SEASON_PASS_OWNED": "Besessen ✓",
  "SEASON_TRACK_FREE": "Kostenlos",
  "SEASON_TRACK_PREMIUM": "Premium",
  "SEASON_CLAIM": "Abholen",
  "SEASON_CLAIMED": "Erhalten ✓",
  "SEASON_LOCKED": "Gesperrt",
  "SEASON_PREMIUM_ONLY": "Nur Premium",
  "SEASON_CLAIMED_COUNT": "{{count}} / {{total}} Belohnungen abgeholt",
  "SEASON_XP_LABEL": "Saison-XP",

  "FRIENDS_TITLE": "Freunde",
  "FRIENDS_TAB_FRIENDS": "Freunde",
  "FRIENDS_ADD_PLACEHOLDER": "Spielercode eingeben (#XXXXXX)",
  "FRIENDS_SEND_REQUEST": "Anfrage senden",
  "FRIENDS_REMOVE": "Entfernen",
  "FRIENDS_CHALLENGE_SENT": "Herausforderung gesendet! 60 Sekunden Zeit.",

  "REPLAY_TITLE": "Spielverlauf",
  "REPLAY_EMPTY": "Noch keine Matches gespielt.",
  "REPLAY_OUTCOME_WIN": "Sieg",
  "REPLAY_OUTCOME_LOSS": "Niederlage",
  "REPLAY_OUTCOME_DRAW": "Unentschieden",
  "REPLAY_VIEW_BUTTON": "Replay",
  "REPLAY_NO_DATA": "Keine Replay-Daten verfügbar.",
  "REPLAY_TIMELINE_TITLE": "Match-Zeitlinie",
  "REPLAY_HP_CHART_LABEL": "HP-Verlauf",
  "REPLAY_GOLD_CHART_LABEL": "Gold-Verlauf",
  "REPLAY_EVENTS_LABEL": "Schlüsselereignisse",
  "REPLAY_CLOSE": "Schließen",
  "REPLAY_PLAY": "Wiedergabe",
  "REPLAY_PAUSE": "Pause",
  "REPLAY_MY_HP":      "Meine HP",
  "REPLAY_OPP_HP":     "Gegner HP",
  "REPLAY_HP_CHART":   "HP-Verlauf",
  "REPLAY_KEY_EVENTS": "Schlüsselereignisse",
  "REPLAY_VIEW_BTN":   "Replay",

  "PROFILE_TITLE": "Mein Profil",
  "PROFILE_STATS": "Statistiken",
  "PROFILE_AVATAR": "Avatar wählen",
  "PROFILE_BIO": "Bio",
  "PROFILE_SAVE": "Speichern",
  "PROFILE_SAVED": "Gespeichert!",
  "PROFILE_WINRATE": "Siegquote",

  "SEASON_ENDS_IN": "Saison endet in {{days}} Tagen",
  "SEASON_ENDED": "Saison beendet! Hole deine Belohnungen.",
  "SEASON_CLAIM_REWARDS": "Belohnungen einlösen",
  "SEASON_REWARDS_CLAIMED": "Belohnungen erhalten!",
  "SEASON_NEXT": "Nächste Saison",
  "SEASON_TITLE_EARNED": "Errungener Titel",

  "SPECTATOR_TITLE":   "Live-Matches",
  "SPECTATOR_LIVE":    "LIVE",
  "SPECTATOR_EMPTY":   "Keine aktiven Matches gerade.",
  "SPECTATOR_WATCH":   "Zuschauen",
  "SPECTATOR_LEAVE":   "Beenden",
  "SPECTATOR_PLAYER1": "Spieler 1",
  "SPECTATOR_PLAYER2": "Spieler 2",
  "SPECTATOR_BACK":    "Zurück",

  "TOURNAMENT_TITLE":          "Turnier",
  "TOURNAMENT_JOIN":           "Beitreten",
  "TOURNAMENT_JOINED":         "Erfolgreich beigetreten!",
  "TOURNAMENT_FULL":           "Turnier ist voll!",
  "TOURNAMENT_BRACKET":        "Turnierbaum",
  "TOURNAMENT_MY":             "Mein Turnier",
  "TOURNAMENT_EMPTY":          "Kein offenes Turnier. Schau später wieder vorbei!",
  "TOURNAMENT_STATUS_OPEN":    "Offen",
  "TOURNAMENT_STATUS_RUNNING": "Laufend",
  "TOURNAMENT_CHAMPION":       "Champion",

  "CHAT_PLACEHOLDER":     "Nachricht...",
  "CHAT_SEND":            "Senden",
  "CHAT_TOGGLE":          "Chat",
  "CHAT_NO_MESSAGES":     "Noch keine Nachrichten",
  "CHAT_QUICK_PHRASE_GG": "GG — Schnellnachricht senden",
  "CHAT_RATE_LIMIT":      "Bitte warte kurz bevor du erneut sendest.",

  "STREAK_TITLE":      "Login-Belohnung",
  "STREAK_BROKEN":     "Streak verloren — aber heute neu gestartet!",
  "STREAK_DAY":        "Tag {{day}} Login-Belohnung",
  "STREAK_CLAIM":      "Einsammeln!",
  "STREAK_JACKPOT":    "7-Tage-Streak abgeschlossen!",
  "STREAK_DAYS_LABEL": "Streak: {{day}} Tag{{plural}}",

  "CLAN_TITLE":       "Clans",
  "CLAN_MY":          "Mein Clan",
  "CLAN_SEARCH":      "Suchen",
  "CLAN_CREATE":      "Erstellen",
  "CLAN_LEADERBOARD": "Rangliste",
  "CLAN_JOIN":        "Beitreten",
  "CLAN_LEAVE":       "Verlassen",
  "CLAN_NAME":        "Clan-Name",
  "CLAN_TAG":         "Tag",
  "CLAN_DESC":        "Beschreibung",
  "CLAN_FULL":        "Clan ist voll (max. 50 Mitglieder)",
  "CLAN_EMPTY":       "Keine Clans gefunden",
  "CLAN_CREATED":     "Clan erstellt",
  "CLAN_JOINED":      "Beigetreten",
  "CLAN_LEFT":        "Clan verlassen",
  "CLAN_OWNER":       "Anführer",
  "CLAN_MEMBER":      "Mitglied",
  "CLAN_OFFICER":     "Offizier",
  "CLAN_NOT_IN_CLAN":        "Du bist in keinem Clan",
  "CLAN_TOTAL_ELO":          "ELO gesamt",
  "CLAN_SEARCH_PLACEHOLDER": "Clan-Name / TAG suchen…",
  "CLAN_TAG_HINT":           "3–5 Großbuchstaben oder Ziffern (z.B. FIRE)"
}
